import { useThemeProvider } from './use-theme-provider';
import { ThemeProviderContext } from './use-theme-provider';
import { DEFAULT_STORAGE_KEY } from './theme-provider.domain';
import type { Theme } from './theme-provider.domain';

interface ThemeProviderProps {
  children: React.ReactNode;
  defaultTheme?: Theme;
  storageKey?: string;
}

export function ThemeProvider({
  children,
  defaultTheme = 'system',
  storageKey = DEFAULT_STORAGE_KEY,
  ...props
}: ThemeProviderProps) {
  const f = useThemeProvider({ defaultTheme, storageKey });

  return (
    <ThemeProviderContext.Provider {...props} value={f.value}>
      {children}
    </ThemeProviderContext.Provider>
  );
}
